export default /* graphql */ `
fragment news on News {
  sys { id }
  contentfulMetadata {
    tags {
      id
      name
    }
  }
  title
  slug
  seo { ...seo }
  date
  category
  copy { json }
  image
  heroImage {
    width
    height
    thumbnail: url(transform: {
      width: 800,
      format: JPG,
      quality: 90
    })
    large: url(transform: {
      width: 1200,
      format: JPG,
      quality: 90
    })
    xlarge: url(transform: {
      width: 2400,
      format: JPG,
      quality: 90
    })
  }
  sectionsCollection(limit: 20) {
    total
    items {
      ... on ModuleText {
        __typename
        sys { id }
        copy {
          json
        }
        callToAction {
          ...link
        }
      }
      ... on ModuleVideo {
        __typename
        sys { id }
        video
        youtubeId
        thumbnail {
          title
          url(transform: {
            width: 1440,
            format: JPG,
            quality: 90
          })
        }
        download
      }

      ... on ModuleQuote {
        __typename
        sys { id }
        quote
        attribution
      }

      ... on ModuleImageGallery {
        __typename
        sys { id }
        title
        images
        description {
          json
        }
        showTitle
      }

      ... on ModuleFaq {
        __typename
        sys { id }
        itemsCollection(limit: 20) {
          total
          items {
            sys { id }
            title
            content {
              json
              links {
                assets {
                  block {
                    sys {
                      id
                    }
                    url
                    title
                    width
                    height
                    description
                  }
                }
              }
            }
            callToAction {
              ...link
            }
          }
        }
      }

      ... on ModuleContentCarousel {
        __typename
        sys { id }
        itemsCollection {
          total
          items {
            sys { id }
            title
            copy
            thumbnail {
              title
              url(transform: {
                width: 628,
                height: 420,
                resizeStrategy: THUMB,
                resizeFocus: CENTER,
                format: JPG,
                quality: 90
              }) 
            }
          }
        }
      }

      ... on ModuleContentGrid {
        __typename
        sys { id }
        title
        showTitle
        itemsCollection {
          total
          items {
            sys { id }
            title
            copy
            thumbnail {
              title
              url(transform: {
                width: 628,
                height: 420,
                resizeStrategy: THUMB,
                resizeFocus: CENTER,
                format: JPG,
                quality: 90
              }) 
            }
            callToAction {
              ...link
            }
          }
        }
      }

      ... on ModuleNavigationAnchor {
        __typename
        sys { id }
        title
        slug
      }
    }
  }
}
`
